import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, themes, Confirm } from 'libs/ui';

export const CountersListRow = (props) => {
  const { row, onDel } = props;
  const { t } = useTranslation();
  const [form, setForm] = useState('');

  const del = () => {
    setForm('delConfirm');
  };

  const closeConfirm = () => {
    setForm('');
  };

  const delAction = () => {
    closeConfirm();
    onDel(row.client_counter_id);
  };

  return (
    <tr>
      <td>{row.zone_id}</td>
      <td>{row.is_hidden ? t('grid.Нет') : t('grid.Да')}</td>
      <td>
        <Button theme={themes.red} onClick={del}>
          Удалить
        </Button>
        {form === 'delConfirm' && (
          <Confirm
            title={t('messages.Счетчик') + ' ' + row.zone_id + ' ' + t('messages.будет удален. Продолжить?')}
            width="440px"
            type="danger"
            cancelButton={{ text: t('buttons.Отмена'), func: closeConfirm }}
            acceptButton={{ text: t('buttons.Удалить'), func: delAction, theme: themes.red }}
          />
        )}
      </td>
    </tr>
  );
};
